// 新聞留言輸入筐
import Image from 'next/image';
import { DEFAULT_USER_IMG } from '@/common/constant';

const NewsCommentInputComponent = ({
    type,
    showComment,
    user,
    comment,
    setComment,
    onFocus,
    onBlur,
    inputRef,
    placeholder,
    onSubmit,
    t,
}) => {
    if (type === 'modal')
        return (
            <div
                className={`hidden ulg:block mt-[30px] space-y-[12px] fixed z-[4]
        w-full bg-black border-t-1 border-black8 left-0 pt-[15px] trans px-[18px] pb-[30px] mb-0
        duration-500 uxs:px-[10px] uxs:pb-[20px]
        ${showComment ? 'bottom-[56px]' : 'bottom-[-350px]'}`}
            >
                <div className="flex gap-x-[10px] flex-col gap-y-[10px] items-start">
                    <div className="between-center w-full">
                        <div className="flex items-center gap-x-[12px]">
                            {/* 使用者頭像 */}
                            <div className="img-box !overflow-visible aspect-[1/1] flex-shrink-0 w-[30px]">
                                <Image
                                    className={`${
                                        user?.avatarFrame ? 'set-center !w-[95%] !h-[95%]' : ''
                                    } rounded-[50%]`}
                                    width={60}
                                    height={60}
                                    src={user?.image || DEFAULT_USER_IMG}
                                    alt="thumbnail"
                                />

                                {/* 如果有頭像框 */}
                                {user?.avatarFrame && (
                                    <Image
                                        className="!z-[2] set-center !object-contain !h-[110%] !w-[110%] !max-w-[unset]"
                                        width={60}
                                        height={60}
                                        src={user?.avatarFrame}
                                        alt="frame"
                                        sizes="60px"
                                    />
                                )}
                            </div>

                            {/* 使用者名稱 */}
                            <p className="text-white text-btn1">{user?.nickname}</p>
                        </div>

                        {/* 評論字數 */}
                        <p className="text-btn2 text-[#FFDDF3] text-right flex-shrink-0">
                            {comment.length}／1000
                        </p>
                    </div>

                    <div
                        className="rounded-[400px] bg-black2 bg-opacity-[.1] flex-grow between-center gap-x-[10px]
                        flex-col flex bg-transparent w-full gap-y-[15px] p-0"
                    >
                        <textarea
                            className="flex-grow text-btn1 text-white placeholder:text-black4 bg-black2 bg-opacity-[.1]
                        w-full text-left p-[20px] rounded-[12px] h-[200px] resize-none umd:text-bd1m umd:pt-[15px]"
                            type="text"
                            placeholder={placeholder}
                            value={comment}
                            maxLength={1000}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            onChange={(e) => setComment(e.target.value)}
                        />

                        {/* 發送按鈕 */}
                        <button
                            disabled={comment.trim() === ''}
                            onClick={onSubmit}
                            className="gtm-btn-send bg-bou text-btn1 text-white rounded-[400px] text-center py-[12px] w-[90px] trans hover:bg-purple9 w-full disabled:bg-black7"
                        >
                            {t('SEND')}
                        </button>
                    </div>
                </div>
            </div>
        );

    if (type === 'inline')
        return (
            <div className="space-y-[12px] mt-[30px]">
                <div className="flex items-center gap-x-[10px]">
                    <div className="between-center">
                        <div className="flex items-center gap-x-[12px]">
                            {/* 使用者頭像 */}
                            <div className="img-box !overflow-visible w-[60px] aspect-[1/1] flex-shrink-0 uxs:w-[50px]">
                                <Image
                                    className={`${
                                        user?.avatarFrame ? 'set-center !w-[95%] !h-[95%]' : ''
                                    } rounded-[50%]`}
                                    width={60}
                                    height={60}
                                    src={user?.image || DEFAULT_USER_IMG}
                                    alt="thumbnail"
                                />

                                {/* 如果有頭像框 */}
                                {user?.avatarFrame && (
                                    <Image
                                        className="!z-[2] set-center !object-contain !h-[110%] !w-[110%] !max-w-[unset]"
                                        width={60}
                                        height={60}
                                        src={user?.avatarFrame}
                                        alt="frame"
                                        sizes="60px"
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    <div
                        className="py-[4px] rounded-[400px] bg-black2 bg-opacity-[.1] flex-grow pl-[20px] pr-[5px] between-center gap-x-[10px] uxs:pl-[15px]
                        max-w-[calc(100%-70px)] usx:max-w-[calc(100%-60px)]"
                    >
                        {/* 輸入筐 */}
                        <input
                            className="flex-grow text-btn1 text-white placeholder:text-white bg-transparent umd:text-bd1m
                            max-w-[calc(100%-125px)] usx:max-w-[calc(100%-110px)]"
                            type="text"
                            placeholder={placeholder}
                            value={comment}
                            maxLength={1000}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            onChange={(e) => setComment(e.target.value)}
                            ref={inputRef}
                        />

                        {/* 發送按鈕 */}
                        <button
                            disabled={comment.trim() === ''}
                            onClick={onSubmit}
                            className="gtm-btn-send bg-bou text-btn1 text-white rounded-[400px] text-center py-[12px] w-[90px] trans hover:bg-purple9 disabled:bg-black7 usx:w-[80px] flex-shrink-0"
                        >
                            {t('SEND')}
                        </button>
                    </div>
                </div>

                {/* 評論字數 */}
                <p className="text-btn2 text-black4 text-right flex-shrink-0">
                    {comment.length}／1000
                </p>
            </div>
        );
};

export default NewsCommentInputComponent;
